// extracted by mini-css-extract-plugin
export default {"root":"circleprogress_root__l12ld"};